import { FunctionComponent, PropsWithChildren, useContext } from 'react';

import { ThemeProvider } from '@mui/material';
import isFunction from 'lodash/isFunction';

import Dialog from '../ui/Dialog';
import { ModalContext } from './ModalContext';
import { modalTheme } from './modal/modal.theme';
import { ModalContextModel } from './models/modal-context.model';
import { ModalPropsModel } from './models/modal-props.model';

const Modal: FunctionComponent<ModalPropsModel> = (
  props: PropsWithChildren<ModalPropsModel>
): JSX.Element => {
  const portalElement = document.getElementById('overlays') as HTMLElement;

  const ctx = useContext(ModalContext) as ModalContextModel;

  const handleClose = () => {
    ctx.modalStateHandler();

    if (isFunction(props.onClose)) {
      props.onClose();
    }
  };

  return (
    <ThemeProvider theme={modalTheme}>
      <Dialog
        open={ctx.isOpen}
        onClose={handleClose}
        container={portalElement}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {props.children}
      </Dialog>
    </ThemeProvider>
  );
};

export default Modal;
